// <s-recently-viewed> — remembers viewed products in localStorage and lists the others; stays hidden when there are none.
const STORAGE_KEY = 'mia:recently-viewed';
const MAX_ITEMS = 8;

class SRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.#readCurrent();
    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      items = [];
    }
    if (!Array.isArray(items)) items = [];

    const others = items.filter((item) => item && item.handle !== current?.handle).slice(0, 4);
    if (current) {
      const next = [current, ...items.filter((item) => item && item.handle !== current.handle)].slice(0, MAX_ITEMS);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // Storage can be unavailable (private mode); the list simply stays empty.
      }
    }

    const list = this.querySelector('[data-recent-list]');
    const template = this.querySelector('template[data-recent-card]');
    if (!list || !template || others.length === 0) return;

    for (const item of others) {
      const card = template.content.firstElementChild.cloneNode(true);
      card.querySelectorAll('[data-recent-link]').forEach((link) => {
        link.href = item.url;
      });
      card.querySelector('[data-recent-link]')?.setAttribute('aria-label', item.title);
      const img = card.querySelector('[data-recent-image]');
      if (img && item.image) {
        img.src = item.image;
        img.alt = item.title;
      } else {
        img?.remove();
      }
      const title = card.querySelector('[data-recent-title]');
      if (title) title.textContent = item.title;
      const price = card.querySelector('[data-recent-price]');
      if (price) price.textContent = item.price;
      list.append(card);
    }
    this.hidden = false;
  }

  #readCurrent() {
    try {
      return JSON.parse(this.querySelector('[data-recent-current]')?.textContent || 'null');
    } catch {
      return null;
    }
  }
}

if (!customElements.get('s-recently-viewed')) customElements.define('s-recently-viewed', SRecentlyViewed);
